<template>
  <div class="page page--convert">
    <Head>
      <title>{{ $t("speed-converter-title") }} - {{ $t("speed-title") }}</title>
      <body class="site--speed" />
      <meta
        name="description"
        :content="$t('page.speed-converter.description')"
      />
      <meta name="og:title" :content="$t('speed-converter-title')" />
      <meta
        name="og:description"
        :content="$t('page.speed-converter.description')"
      />
    </Head>
    <h1>
      <router-link :to="pathForLocale({ path: '/how-fast-am-i-going' })">{{
        $t("speed-converter-title")
      }}</router-link>
    </h1>
    <AdUnit unit="1" />
    <SpeedConverter />
    <AdUnit unit="2" />
    <TheFooter
      :fast="false"
      :elevation="true"
      :title="$t('page.speed-converter.heading')"
    >
      <div class="section section--about">
        <div class="text-block" v-html="$t('page.speed-converter.html')"></div>
      </div>
      <template v-slot:nav>
        <li>
          <router-link :to="pathForLocale({ path: '/how-fast-am-i-going' })">{{
            $t("speed-title")
          }}</router-link>
        </li>
        <li>
          <router-link :to="pathForLocale({ path: '/speed-calculator' })">{{
            $t("speed-calculator-title")
          }}</router-link>
        </li>
        <li>
          <router-link :to="pathForLocale({ path: '/speed-converter' })">{{
            $t("speed-converter-title")
          }}</router-link>
        </li>
      </template>
    </TheFooter>
  </div>
</template>
<script>
import { Head } from "@vueuse/head";
import { pathForLocale } from "@/helpers";
import TheFooter from "@/components/TheFooter.vue";
import AdUnit from "@/components/AdUnit.vue";
import SpeedConverter from "@/components/SpeedConverter.vue";

export default {
  components: {
    TheFooter,
    AdUnit,
    SpeedConverter,
    Head
  },
  data() {
    return {};
  },
  methods: {
    pathForLocale
  }
};
</script>
